import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

/**
 * Converts duration in seconds to ISO 8601 format.
 * If input is invalid or undefined, defaults to 60 seconds (PT1M).
 */
export function formatDurationToISO(
  durationInSeconds?: number | string
): string {
  const validSeconds = Number(durationInSeconds);

  // Handle invalid, null, undefined, or NaN
  const seconds = isNaN(validSeconds) || validSeconds <= 0 ? 60 : validSeconds;

  const dur = dayjs.duration(seconds, "seconds");
  const mins = dur.minutes();
  const secs = dur.seconds();

  if (mins > 0 && secs > 0) return `PT${mins}M${secs}S`;
  if (mins > 0) return `PT${mins}M`;
  return `PT${secs}S`;
}
